/**
 * Workbench version/history should list only non-rerun analysis passes.
 * Treat missing `is_rerun` as a first run (backward compatible with older API payloads).
 */
export function isWorkbenchNonRerunRun(entry: unknown): boolean {
  if (entry == null || typeof entry !== 'object') return false;
  return (entry as { is_rerun?: boolean }).is_rerun !== true;
}
